import { ReactElement } from 'react'
import woman from './assets/image.png'
import * as S from './styled'

export default function HowItWorks (): ReactElement {
  return <S.Container id="como-funciona">
    <S.Content>
      <S.TextContent>
        <h1>Como funciona</h1>

        <p>Para garantir o <strong>desconto no valor das consultas</strong> e <strong>exames</strong>, basta informar o seu CPF no agendamento</p>

        <p><strong>Nas farmácias Droga Raia e Drogasil, para obter descontos em medicamentos,</strong> basta informar o número do seu CPF no balcão da loja, assim como nos demais parceiros.</p>

        <p>Acesse o site do sócio-torcedor do seu clube e saiba como aderir!</p>
      </S.TextContent>

      <S.ImageContainer>
        <S.ImageBg>
          <img src={woman} alt="" />
        </S.ImageBg>
      </S.ImageContainer>
    </S.Content>
  </S.Container>
}
